import React from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from '../../../../utils/cn';
import AppIcon from '../../../../components/AppIcon';

interface FeedbackTextAreaProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
}

const FeedbackTextArea: React.FC<FeedbackTextAreaProps> = ({ value, onChange, placeholder }) => {
  const { t } = useTranslation();
  const maxLength = 500;
  const remaining = maxLength - value.length;

  return (
    <div className="mb-6">
      <p className="text-sm font-medium text-foreground mb-2">
        {t('performance.espn.feedbackLabel')}
      </p>
      <textarea
        rows={6}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        maxLength={maxLength}
        placeholder={placeholder}
        className="w-full rounded-lg border border-border bg-card px-3 py-2 text-sm text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/20 focus-visible:border-primary resize-y mb-2"
      />
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <AppIcon name="Info" size={14} className="text-muted-foreground me-1" />
          <span className="text-xs text-muted-foreground">
            {t('performance.espn.feedbackHint')}
          </span>
        </div>
        <span
          className={cn(
            'text-xs',
            remaining < 50 ? 'text-amber-500' : 'text-muted-foreground'
          )}
        >
          {t('performance.espn.charactersRemaining', { count: remaining })}
        </span>
      </div>
    </div>
  );
};

export default FeedbackTextArea;
